var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShirt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56.966,
    viewBox: "0 0 56 56.966",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;}.a{stroke:#4c4c4e;stroke-linecap:round;stroke-linejoin:round;}.b{fill:#4c4c4e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.203 4.41)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.476,50.757V22.531a20.2,20.2,0,0,1,1.648-8.468L25.46,4.625a1.974,1.974,0,0,0,.087-.706.673.673,0,0,0-.173-.353l-.26-.265a.726.726,0,0,0-.52-.176H17.829a1.238,1.238,0,0,0-.607.176l-.26.265c0,.088-.087.265-.087.353a1.525,1.525,0,0,0,.087.617l3.382,7.5h0l.867,1.941",
    transform: "translate(1.335 -3.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.8,3.25l4.856,3.793-2.775,6.616-3.035-2.117a1.485,1.485,0,0,0-1.214-.265,2.063,2.063,0,0,0-1.127.794",
    transform: "translate(2.739 -3.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.481,3.25,13.625,7.043,16.4,13.659l3.035-2.117a1.485,1.485,0,0,1,1.214-.265,1.255,1.255,0,0,1,.954.794",
    transform: "translate(0.076 -3.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31.4,34.605l2.6,11.467,6.07-.882L34.613,11.318a2.825,2.825,0,0,0-1.387-2.029l-6.85-3.352",
    transform: "translate(5.015 -1.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.421,34.605,9.82,46.072,3.75,45.19,9.213,11.318A2.825,2.825,0,0,1,10.6,9.289l6.85-3.352",
    transform: "translate(-3.75 -1.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10,14.375V42.6c4.162,0,5.463,3.528,13.874,3.528S33.586,42.6,37.748,42.6V14.375",
    transform: "translate(-1.329 1.502)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y1: 1.058,
    x2: 6.157,
    transform: "translate(38.24 38.635)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 6.157,
    y1: 1.058,
    transform: "translate(0.694 38.635)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.075,15.764a.694.694,0,1,0-.694.7h0A.633.633,0,0,0,21.075,15.764Z",
    transform: "translate(2.945 1.785)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.694,
    cy: 0.694,
    r: 0.694,
    transform: "translate(23.586 12.437)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.012,19.286a.694.694,0,1,0-.724.664h0A.685.685,0,0,0,21.012,19.286Z",
    transform: "translate(2.92 3.225)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.012,22.786a.694.694,0,1,0-.724.664h0A.685.685,0,0,0,21.012,22.786Z",
    transform: "translate(2.92 4.664)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.075,26.319a.694.694,0,1,0-.694.694h0a.7.7,0,0,0,.694-.694Z",
    transform: "translate(2.945 6.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.075,29.881a.694.694,0,1,0-.694.694h0A.7.7,0,0,0,21.075,29.881Z",
    transform: "translate(2.945 7.595)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.012,33.349a.694.694,0,1,0-.724.664h0A.685.685,0,0,0,21.012,33.349Z",
    transform: "translate(2.92 9.009)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M29.868,22.277a.809.809,0,0,1-.78.882H24.405a.809.809,0,0,1-.78-.882h0V15.75h6.243Z",
    transform: "translate(3.95 2.068)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 56,
    height: 56.966
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShirt);
export default __webpack_public_path__ + "static/media/Shirt.4301499399ab7c95ae1ec1329e0e1e97.svg";
export { ForwardRef as ReactComponent };